import RequestHandler from './utils/request-handler.js';
import LoadingOverlay from './loading-overlay.js';

export default class MyaccountLogin {
    constructor() {
        this.requestHandler = new RequestHandler;
        this.loginForm = document.querySelector('form[name="registration_complete"]');
        this.submitButton = document.querySelector('#registration_complete_submit');
        this.myAccountAutoLoginUrl = this.loginForm.dataset.myaccountAutologinUrl;
        this.myAccountRegistrationUrl = this.submitButton.dataset.myaccountRegisterUrl;
        this.loadingOverlay = new LoadingOverlay;
        this.errorSection = document.querySelector('[data-registration-error]');
        this.passwordElement = document.querySelector('#registration_complete_password_first');
        this.confirmPasswordElement = document.querySelector('#registration_complete_password_second');
    }

    setup() {
        this.setupMALoginListener();
        this.setupPasswordValidatorListener();
    }

    setupMALoginListener() {
        this.loginForm.addEventListener('submit', (e) => {
            this.errorSection.classList.remove('show');
            this.errorSection.classList.add('hide');
            if (this.loginForm.checkValidity()) {
                e.preventDefault();
                let postParams = new FormData(this.loginForm);

                this.loadingOverlay.taskStarted();
                this.requestHandler.post(this.myAccountRegistrationUrl,
                    this.serialize(postParams),
                    this.registrationResponseProcessorCallBack.bind(this)
                );
            }
        });
    }

    responseProcessorCallBack(response) {
        if (response.hasOwnProperty('status')) {
            this.errorSection.innerHTML = response.message;
            if (response.status == 'non-recoverable-error') {
                let aTag = document.createElement('a');
                aTag.setAttribute('href', '/my-account/register');
                aTag.innerText = 'Register - My Account';
                this.errorSection.appendChild(aTag);
            }
            this.errorSection.classList.remove('hide');
            this.errorSection.classList.add('show');
        } else {
            response.route = 'token';
            response.username = parseInt(document.querySelector('#registration_complete_orderId').value);
            let expiryDate = this.calculateCookieExpiryTime();
            let cookiePath = '/';
            if (this.myAccountAutoLoginUrl.includes('my-account') === true) {
                cookiePath = '/my-account/';
            }
            document.cookie = 'authorization=' + encodeURIComponent(JSON.stringify(response)) + ';path=' + cookiePath + ';expires=' + expiryDate;
            window.open(this.myAccountAutoLoginUrl, '_self');
        }
    }

    registrationResponseProcessorCallBack(response) {
        if (response.status == 'success') {
            const orderId = document.querySelector('#registration_complete_orderId').value;
            const password = document.querySelector('#registration_complete_password_first').value;
            let data = `username=${orderId}&password=${password}`;
            this.requestHandler.post('/oauth/v2/token',
                data,
                this.responseProcessorCallBack.bind(this)
            );
        } else if (response.status == 'validation-error') {
            $('form[name="registration_complete"]').html(response.html);
            let helpBlocks = document.querySelectorAll('span.help-block');
            for (const span of helpBlocks) {
                span.classList.add('show');
            }
        } else if (response.hasOwnProperty('status')) {
            this.errorSection.innerHTML = response.message;
            if (response.status == 'non-recoverable-error') {
                let aTag = document.createElement('a');
                aTag.setAttribute('href', '/my-account/register');
                aTag.innerText = 'Register - My Account';
                this.errorSection.appendChild(aTag);
            }
            this.errorSection.classList.remove('hide');
            this.errorSection.classList.add('show');

        }
    }

    calculateCookieExpiryTime() {
        const now = moment();
        let thirty = moment(now).add(60, 'minutes');
        return thirty.toDate();
    }

    serialize(data) {
        let obj = {};
        for (let [key, value] of data) {
            if (obj[key] !== undefined) {
                if (!Array.isArray(obj[key])) {
                    obj[key] = [obj[key]];
                }
                obj[key].push(value);
            } else {
                obj[key] = value;
            }
        }
        return obj;
    }

    setupPasswordValidatorListener() {
        this.passwordElement.addEventListener('focusout', () => {
            let formGroupElement = this.passwordElement.closest('.form-group');
            formGroupElement.classList.add('is-valid');
            formGroupElement.classList.remove('is-invalid');
            let spanErrorElements = document.querySelector('.password-error');
            if (spanErrorElements) {
                spanErrorElements.parentNode.removeChild(spanErrorElements);
            }
            const pattern = new RegExp('^((?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])|(?=.*[a-z])(?=.*[A-Z])(?=.*[^0-9a-zA-Z])|(?=.*[A-Z])(?=.*[0-9])(?=.*[^0-9a-zA-Z])|(?=.*[a-z])(?=.*[0-9])(?=.*[^0-9a-zA-Z]))', 'i');
            if (pattern.test(this.passwordElement.value) === false) {
                formGroupElement.classList.add('is-invalid');
                formGroupElement.classList.remove('is-valid');
                let span = document.createElement('span');
                span.classList.add('help-block', 'show', 'password-error');
                span.innerHTML = 'Your password does not meet the minimum requirements. Passwords must include: 1 lowercase character, 1 uppercase character, 1 number and 1 non-alphanumeric character.';
                this.passwordElement.parentNode.insertBefore(span, this.passwordElement.nextSibling);
            }
        });

        this.confirmPasswordElement.addEventListener('focusout', () => {
            let formGroupElement = this.confirmPasswordElement.closest('.form-group');
            formGroupElement.classList.add('is-valid');
            formGroupElement.classList.remove('is-invalid');
            let spanErrorElements = document.querySelector('.confirm-password-error');
            if (spanErrorElements) {
                spanErrorElements.parentNode.removeChild(spanErrorElements);
            }
            if (this.confirmPasswordElement.value !== this.passwordElement.value) {
                formGroupElement.classList.add('is-invalid');
                formGroupElement.classList.remove('is-valid');
                let span = document.createElement('span');
                span.classList.add('help-block', 'show', 'confirm-password-error');
                span.innerHTML = 'Your passwords entered do not match';
                this.confirmPasswordElement.parentNode.insertBefore(span, this.confirmPasswordElement.nextSibling);
            }
        });
    }
}
